import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { faqs } from '../data/faqs';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-cream px-5 py-16 sm:px-8 lg:py-24" data-id="element-40" data-mp="1lc1zxc2r31qn">
      <div className="mx-auto max-w-2xl" data-id="element-41" data-mp="1gdqqv3ka4v9h">
        <SectionHeading overline="Preguntas frecuentes" title={<>
              Preguntas{' '}
              <span className="italic text-terracotta-500" data-id="element-43" data-mp="2dyd7x7sos4xh">frecuentes</span>
            </>} data-id="element-42" data-mp="1gal2jqjh5xet" />

        <ul className="mt-10 divide-y divide-gold-200/70 border-y border-gold-200/70" data-id="element-44" data-mp="28za4frscu6rm">
          {faqs.map((faq, index) => {
          const isOpen = open === index;
          const Icon = isOpen ? MinusIcon : PlusIcon;
          return <li key={faq.question} data-id="element-45" data-mp="sn3cbzfuz7dy" data-mpi={index}>
                <h3 data-id="element-46" data-mp="so68als1g00q">
                  <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-6 py-5 text-left transition-colors duration-200 ease-soft hover:text-sage-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-500" data-id="element-47" data-mp="soeig5ws0r88">
                    <span className="font-serif text-[1.15rem] leading-snug text-sage-800" data-id="element-48" data-mp="fj8h3klb05ah">
                      {faq.question}
                    </span>
                    <Icon className="h-4 w-4 flex-none text-gold-600" aria-hidden="true" data-id="element-49" data-mp="6qwts7lhkxyq" />
                  </button>
                </h3>
                <div id={`faq-panel-${index}`} hidden={!isOpen} className="pb-6 pr-8 text-[14.5px] leading-relaxed text-ink-soft" data-id="element-50" data-mp="bjpxqt94s29r">
                  {faq.answer}
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}